import r from"./isArray.js";import o from"./_isKey.js";import t from"./_stringToPath.js";import i from"./toString.js";var m=r,s=o,a=t,f=i;var n=function(r,o){return m(r)?r:s(r,o)?[r]:a(f(r))};export{n as default};
//# sourceMappingURL=_castPath.js.map
